export class SafeError<C extends string | number = number, D = any> extends Error {
  code: C | undefined;
  data: D | undefined;
  constructor(cause?: string | Error, code?: C, data?: D) {
    if (cause instanceof Error) {
      return Object.assign(cause, {
        code,
        data,
      });
    } else {
      super(cause || 'Unknown error.');
      this.code = code;
      this.data = data;
    }
  }
}

/**
 * @deprecated Use SafeError instead
 */
export const CodeError = SafeError;
